export default __webpack_public_path__ + "static/media/quora.997c8600.png";